import { Center } from '@zorro/web/design-system';
import React from 'react';

import { SVGIconProps } from '../types';

type Props = {
  style?: SVGIconProps;
  className?: string;
};

export const FoldedMapIcon = ({ style, className }: Props) => {
  return (
    <Center style={style} className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <g clipPath="url(#clip0_462_17562)">
          <path
            d="M9.99927 15.4166L7.49927 14.1666M7.49927 14.1666L2.49927 16.6666V5.83325L7.49927 3.33325M7.49927 14.1666V3.33325M7.49927 3.33325L12.4993 5.83325M12.4993 5.83325L17.4993 3.33325V9.58325M12.4993 5.83325V10.4166M15.8326 14.9999V15.0083M17.6001 16.7673C17.9498 16.4177 18.188 15.9723 18.2845 15.4873C18.381 15.0023 18.3316 14.4996 18.1424 14.0428C17.9532 13.5859 17.6327 13.1954 17.2216 12.9207C16.8105 12.6459 16.3271 12.4993 15.8326 12.4993C15.3381 12.4993 14.8547 12.6459 14.4436 12.9207C14.0325 13.1954 13.712 13.5859 13.5228 14.0428C13.3336 14.4996 13.2842 15.0023 13.3807 15.4873C13.4772 15.9723 13.7154 16.4177 14.0651 16.7673C14.4134 17.1165 15.0026 17.6382 15.8326 18.3332C16.7084 17.5915 17.2984 17.0698 17.6001 16.7673Z"
            stroke="#1A1721"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_462_17562">
            <rect
              width="20"
              height="20"
              fill="white"
              transform="translate(-0.000732422)"
            />
          </clipPath>
        </defs>
      </svg>
    </Center>
  );
};
